import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { intelDataProvider } from './dataProvider';

export function initSocialTradingIntelDataProvider() {
  registerModuleDataProvider(Resources.socialTradingIntel, intelDataProvider);
}

initSocialTradingIntelDataProvider();
